import "./Video.css";

const Video = () => (
  <div className="videoContainer">
    <video className="video" src="video.mov" autoPlay loop muted playsInline />
  </div>
);

export default Video;
